/**
 * Debug utility for creating namespaced debug loggers
 * You can enable debugging per namespace by passing debug: true
 */

/**
 * Creates a debug logger for a specific namespace
 * @param {string} namespace - The namespace for the logger (e.g., 'strapfinder-drawer')
 * @param {boolean} debug - Whether to enable debugging for this namespace
 * @returns {Object} Object with debug and error logging functions
 */
export function createDebugger(namespace, debug = false) {
    return {
        log(...args) {
            if (debug) {
                console.log(`[${namespace}]`, ...args);
            }
        },
        error(...args) {
            console.error(`[${namespace}]`, ...args);
        },
        warn(...args) {
            console.warn(`[${namespace}]`, ...args);
        }
    };
}
